import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { EffectiveTimeMeasuringView } from "src/components/views/spc/controlChart/dataInput/EffectiveTimeMeasuringView.tsx";

export const Route = createFileRoute("/_authenticated/_shell/spc/timeMeasurement")({
	staticData: { title: i18n.t("time_measurement"), legacyViewKey: "effectiveTimeMeasurementView" },
	component: RouteComponent,
});

function RouteComponent() {
	return <EffectiveTimeMeasuringView />;
}
